// components/UnifiedDatePicker.jsx
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UnifiedDatePicker = ({
    includeTime = false,
    selected,
    onChange,
    className = "",
    ...props
}) => {
    return (
        <DatePicker
            selected={selected}
            onChange={onChange}
            showTimeSelect={includeTime}
            dateFormat={includeTime ? "Pp" : "P"} // Ej: "04/20/2026 2:30 PM" o "04/20/2026"
            timeIntervals={15} // minutos entre opciones
            timeCaption="Hora"
            calendarClassName="calendar-base" // ← aquí aplicas la clase base
            className={`calendar-input ${className}`} // estiliza el input

            {...props}
        />
    );
};

export default UnifiedDatePicker;